export const SPEEDS = [1, 2, 4, 8, 16];

/** Seconds → m:ss */
export function fmt(sec: number): string {
  const s = Math.max(0, Math.floor(sec));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
}
